export default class Pagination {
  constructor(page = 0, take = 0, skip = 0, sortFld = null, sortDir = null) {
    this.page = page;
    this.take = take;
    this.skip = skip;

    this.sortFld = sortFld;
    this.sortDir = sortDir;

    this._initialTake = take;
  }

  increaseRowsBy(numRows = 0) {
    this.take += numRows;
  }

  resetPagination() {
    this.page = 0;
    this.take = this._initialTake;
    this.skip = 0;
  }

  get pagination() {
    return {
      page: this.page,
      take: this.take,
      skip: this.skip,
    };
  }

  set pagination({ page, nTake, nSkip }) {
    this.page = page;
    this.take = nTake;
    this.skip = nSkip;
  }

  get sorting() {
    return {
      sortDir: this.sortDir,
      sortFld: this.sortFld,
    };
  }

  set sorting({ sortFld, sortDir }) {
    this.sortFld = sortFld;
    this.sortDir = sortDir;
  }
}
